import vue from 'vue';
import Vuex, { createNamespacedHelpers } from 'vuex';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { state } from './state';

vue.use(Vuex);

export const { mapGetters, mapState } =
  createNamespacedHelpers('roiCalculator');

export const masks = {
  money: {
    prefix: '$ ',
  },
  moneyNoPrecision: {
    prefix: '$ ',
    precision: 0,
  },
  number: {
    precision: 0,
  },
  decimal: {
    precision: 2,
  },
  decimalSinglePrecision: {
    precision: 1,
  },
  percent: {
    suffix: '%',
    precision: 0,
  },
};

/**
 * @type {import('vuex').Module<ROICalculatorState>}
 */
const roiCalculator = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export const store = new Vuex.Store({
  strict: true,
  modules: {
    roiCalculator,
  },
});

export { mutation } from './mutations';
export { action } from './actions';

/**
 * @typedef {import('./state').ROICalculatorState} ROICalculatorState
 */
